var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cp-select',_vm._g(_vm._b({attrs:{"config":_vm.routeCnae,"item-value":"id","clearable":"","customItem":true,"return-object":false},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.selected(item))}})]}},{key:"item",fn:function(ref){
var item = ref.item;
return [_vm._v("\n        "+_vm._s(((item.code) + " - " + (item.name)))+"\n    ")]}}])},'cp-select',_vm.attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }